import { Api } from "./Api";
import _ from "lodash";
import { Intervention } from "../models/Intervention";
import Facturation = Intervention.Facturation;

export class FacturationApi extends Api {
    constructor() {
        super("facturation");
    }

    getAll(params?: Object): Promise<Array<Facturation>> {
        return this.getResources(params).then(function (response) {
            var res: Array<Facturation> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new Facturation(d);
                });
            }
            return res;
        });
    }

    get(id: Number, params?: Object): Promise<Facturation> {
        return this.getResource(id, params).then(function (response) {
            return new Facturation(response.data.data);
        });
    }

    save(facturation: Facturation, params?: Object): Promise<Facturation> {
        return super
            .saveResource(facturation.serialize(), params)
            .then(function (response) {
                return new Facturation(response.data.data);
            });
    }

    delete(id: Number, raison: string): Promise<Facturation> {
        return super.deleteResource(id, raison).then(function (response) {
            return new Facturation(response.data.data);
        });
    }
}
